import axios from "axios";
import { API_URL, authHeader } from "./api";

class CheckinFlowService {
  getCommunications() {
    return axios.get(`${API_URL}communications/checkin-flow`, {
      headers: authHeader(),
    });
  }

  getFlowDescription(lang = "en") {
    return axios.get(`${API_URL}communications/checkin-flow-description`, {
      headers: authHeader(),
      params: { lang },
    });
  }

  updateCommunications(data) {
    return axios.patch(`${API_URL}communications/checkin-flow`, data, {
      headers: authHeader(),
    });
  }

  previewEmail(subject, title, body, lang, template, upsells = []) {
    return axios.post(
      `${API_URL}communications/preview-email`,
      { subject, title, body, lang, template, upsells },
      { headers: authHeader() },
    );
  }
}

export default new CheckinFlowService();
